import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { identity, portrait } from '../data/portfolio';
export function Hero() {
  return <header className="mesh relative px-6 pb-14 pt-16 md:px-10 md:pb-16 md:pt-24" data-id="element-138" data-mp="eibl18muc834">
      <div className="relative z-[1] mx-auto w-full max-w-edge" data-id="element-139" data-mp="9ll8uwe5pwmz">
        <div className="grid items-end gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-140" data-mp="4m8nkg2xoxmi">
          <div className="lg:col-span-7" data-id="element-141" data-mp="4jvwndf77cxb">
            <p className="text-[11px] font-medium uppercase tracking-[0.34em] text-brass" data-id="element-142" data-mp="128frdnreylxt">
              {identity.role}
            </p>

            <h1 className="mt-8 font-display text-[3.5rem] font-normal leading-[0.94] tracking-[-0.02em] text-paper sm:text-7xl lg:text-[6.25rem]" data-id="element-143" data-mp="xb5w3rhcfg22">
              Nigel
              <br data-id="element-144" data-mp="nb6njukxbpp7" />
              Grierson
            </h1>

            <p className="mt-9 max-w-xl border-t border-white/15 pt-6 text-sm uppercase tracking-[0.18em] text-fog" data-id="element-145" data-mp="3d1a7phvug7c8">
              {identity.disciplines}
            </p>

            <p className="mt-8 max-w-2xl font-display text-xl font-normal leading-relaxed text-paper/90 md:text-[1.6rem] md:leading-[1.5]" data-id="element-146" data-mp="384js0vnybdrc">
              {identity.statement}
            </p>
          </div>

          <div className="lg:col-span-5" data-id="element-147" data-mp="3o59d9ms2zcg4">
            <div className="relative mx-auto w-full max-w-[26rem] lg:mx-0 lg:ml-auto" data-id="element-148" data-mp="39b4gcyqfxq1v">
              <span className="absolute -left-4 -top-4 hidden h-full w-full border border-brass/60 lg:block" aria-hidden="true" data-id="element-149" data-mp="3e8wjyq0g70lw" />
              <img src={portrait} alt="Portrait of Nigel Grierson" className="portrait relative aspect-[4/5] w-full object-cover object-center" data-id="element-150" data-mp="358rcygz62489" />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-6 border-t border-white/15 pt-6 sm:flex-row sm:items-center sm:justify-between md:mt-20" data-id="element-151" data-mp="2vjq0h0rty4z1">
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-fog" data-id="element-152" data-mp="2hlj983hdz38c">
            {identity.location}
          </p>
          <div className="flex flex-wrap items-center gap-x-10 gap-y-3" data-id="element-153" data-mp="s2jjlmv9pier">
            <a href="#proposition" className="group inline-flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.26em] text-paper transition-colors duration-150 ease-editorial hover:text-brass" data-id="element-154" data-mp="nbbcixheu94r">
              The Board proposition
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-editorial group-hover:translate-x-1" aria-hidden="true" data-id="element-155" data-mp="dbaoiy8lj4u8" />
            </a>
            <a href="#contact" className="inline-flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.26em] text-brass transition-colors duration-150 ease-editorial hover:text-paper" data-id="element-156" data-mp="112pud0zl04a8">
              Appointment enquiries
            </a>
          </div>
        </div>
      </div>
    </header>;
}